import React, { useEffect, useState, Fragment } from 'react';
import {useNavigate } from "react-router-dom";
import PhotoComponentCustom from "../../../../commons/components/Album";
import Loading from '../../../../commons/components/Loading';
import SkeletonLoadingComponent from '../../../../commons/components/SkeletonLoading';
import Slider from "../../../../commons/components/Slider";
import ROUTERS from "../../../../commons/constans/router";
import { formatDateKorea } from '../../../../utils/helpers';
import VideoAllTab from "../videoAllTab";
import InfiniteScroll from 'react-infinite-scroll-component';

type props = {
  data: any,
  showVideo: Boolean,
  isProcessingDel: Boolean,
  isProcessing: Boolean
};

const AllTab = ({
  data, 
  onPhotoClick, 
  photoSelected, 
  showVideo, 
  isProcessingDel, 
  isProcessing,
  params, 
  fetchMoreDataPaginate, 
  lastPage, 
  currentPage
}: props) => {

  const navigate = useNavigate();

  const fetchMoreData = () => {
    let paramPage = {
      ...params,
      page: params.page + 1,
    }
    if (params.page < lastPage) {
      fetchMoreDataPaginate(paramPage);
    }
  }

  useEffect(() => {
    if (Object.keys(data).length <= 3 && currentPage < lastPage) {
      fetchMoreData()
    }
  }, [data])

  const loadingDiv = <div className='pt-3 pl-3 pr-3'>
    <SkeletonLoadingComponent width={100} />
    <SkeletonLoadingComponent cssClass={'photo-selector-slide'} type={'album'} />

    <SkeletonLoadingComponent width={110} />
    <SkeletonLoadingComponent type={'video'} height={183}/>
  </div>

  return (
    <>
      {(isProcessing && lastPage <= 1) || isProcessingDel
        ? loadingDiv
        : (
            !data || Object.keys(data).length <= 0 ? (
              <div className="container mt-5 pt-5">
                <div className="row pt-5">
                  <div className="col-12">
                    <p className="text-center p-0 m-0">해당하는 데이터가 없습니다</p>
                  </div>
                </div>
              </div>
            ) : (
              <InfiniteScroll
                dataLength={Object.keys(data).length}
                next={fetchMoreData}
                hasMore={currentPage < lastPage ? true : false}
                loader={loadingDiv}
              >
                {
                  Object.keys(data).map((day) => (
                    <Fragment key={day}>
                      {(data[day] ?? []).reduce(function (previous, item) {
                          if (item.type !== 'video_message') {
                            return [
                              ...previous, 
                              1
                            ]
                          } else {
                            return previous
                          }
                        }, []).length || showVideo ? (
                        <Fragment>
                          <p className="tabs__content__section__time ml-2 mb-2">
                            {formatDateKorea(day)} {/*2021년 12월 12일*/}
                          </p>
                          {/* <Slider
                            pagination={false}
                            autoplay={false}
                            classSlider="swiper-pagination__custom"
                            classSwiper="swiper-custom"
                            slidesPerView={3}
                          > */}
                          <div className='img-list'>
                            {(data[day] ?? []).reduce(function (previous, item) {
                              if (item.type !== 'video_message') {
                                return [
                                  ...previous, 
                                  <PhotoComponentCustom
                                    key={item.id}
                                    photoClass={`photo-selector-slide`}
                                    src={item.path}
                                    id={item.id}
                                    item={item}
                                    onClick={onPhotoClick}
                                    photoSelected={photoSelected}
                                  />
                                ]
                              } else {
                                return previous
                              }
                            }, [])}
                          </div>
                          {/* </Slider> */}
                          {showVideo && (
                              data[day].reduce(function (previous, item) {
                                if (item.type === 'video_message') {
                                  return [
                                    ...previous, 
                                    <VideoAllTab
                                      key={item.id}
                                      videoDetail={item}
                                      params={params}
                                    />
                                  ]
                                } else {
                                  return previous
                                }
                              }, [])
                          )
                          }
                        </Fragment>
                      ) : null}
                    </Fragment>
                  ))
                }
              </InfiniteScroll>
            )
        )
      }
    </>
  );
};

AllTab.defaultProps = {
  showVideo: true
}

export default AllTab;
